import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

import { commonContentAttributes } from "./commonContentAttributes";

export const okved_out: SugarElementInfo = {
    name: "okved_out",
    availableChildren: { type: AvailableChildrenType.Any },
    attributes: commonContentAttributes,
};
